import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from 'react-redux';
import { setMotoAdverts } from 'shared/actions/motoAdverts';
import { stateDataLayer } from 'shared/modules';
import { setDataLayer } from 'shared/actions/globals';
import API from 'shared/constants/api';
import { FormattedMessage } from 'react-intl';
import { toLocalized } from 'shared/helpers/locale';
import { withFetch } from 'shared/hocs/withFetch';
import Loader from 'shared/components/Loader/Loader';
import Link from 'shared/components/Link/Link';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import AdvertCard from 'desktop/components/AdvertCard/AdvertCard';
import s from './TypeCatalog.css';

class TypeCatalog extends React.Component {
  static propTypes = {
    types: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    motoAdverts: PropTypes.shape(),
    locale: PropTypes.string.isRequired,
    setMotoAdverts: PropTypes.func.isRequired,
    setDataLayer: PropTypes.func.isRequired,
    location: PropTypes.shape(),
    fetch: PropTypes.func.isRequired,
  };
  static defaultProps = {
    motoAdverts: null,
    location: null,
  };

  state = {
    currentType: this.props.types ? this.props.types[0].id : null,
    collapsed: false,
    isFetching: false,
    mounted: false,
  };

  componentDidMount = () => {
    this.setState({ mounted: true });
    this.getAdverts();
  };

  componentDidUpdate = () => {
    this.getAdverts();
  };

  getAdverts = () => {
    const { motoAdverts, fetch } = this.props;
    const { isFetching, currentType: id } = this.state;

    if ((!id || !motoAdverts || !motoAdverts[id]) && !isFetching) {
      this.setState({ isFetching: true });
      fetch(API.ADVERT.ALL(`?transport=${id}`))
        .then(r => r.json())
        .then(r => {
          this.props.setMotoAdverts({ [id]: r.results });
          this.props.setDataLayer(
            stateDataLayer.manipulation({ data: r.results, pagetype: 'searchresults' }),
          );
          this.setState({ isFetching: false });
        });
    }
  };

  handleTypeClick = id => {
    this.setState({ currentType: id, collapsed: false });
  };

  handleShowMoreClick = () => {
    const { collapsed } = this.state;

    if (!collapsed) {
      this.setState({ collapsed: true });
    }
  };

  render() {
    const { types, motoAdverts, locale, location } = this.props;
    const { collapsed, isFetching, mounted } = this.state;
    const currentType = this.state.currentType || types[0].id;
    const adverts = motoAdverts && motoAdverts[currentType];
    const showedAdverts = adverts && adverts.slice(0, collapsed ? 20 : 12);

    const route =
      collapsed &&
      toLocalized(
        `/${(types.find(type => type.id === currentType) || {}).route}/${
          location ? location.slug : ''
        }/`.replace(/\/\//g, '/'),
        locale,
      );

    return (
      <div className={s.root}>
        <div className={s.header}>
          {types.map(({ id, title }) => (
            <span
              onClick={() => this.handleTypeClick(id)}
              key={id}
              className={cx(s.typeBtn, { [s.currentType]: id === currentType })}
            >
              {title}
            </span>
          ))}
        </div>

        <Loader isLoading={!mounted || isFetching} className={s.loader} defaultClassName={s.body}>
          {showedAdverts &&
            showedAdverts.map(advert => (
              <AdvertCard
                advertClassName={s.advert}
                width={182}
                cardType="brick"
                key={advert.id}
                item={advert}
              />
            ))}
        </Loader>

        {collapsed ? (
          <Link to={route} className={s.bottomBtn}>
            <FormattedMessage id={'Показать всё'} />
          </Link>
        ) : (
          <button onClick={this.handleShowMoreClick} className={s.bottomBtn}>
            <FormattedMessage id={'Показать ещё'} />
          </button>
        )}
      </div>
    );
  }
}

const mapStateToProps = store => ({
  motoAdverts: store.motoAdverts,
  locale: store.globals.locale,
  location: store.globals.location,
  store,
});

const mapDispatchToProps = {
  setMotoAdverts,
  setDataLayer,
};

export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withFetch(TypeCatalog)),
);



// WEBPACK FOOTER //
// ./src/desktop/routes/commercial/components/TypeCatalog/TypeCatalog.js